"use strict";
var editor_2d = require("editor-2d");
var lib_core = require("lib-core");

var drawSymbolTerminalDataTo2D = require("./../../../shared/renderData/drawSymbolTerminalDataTo2D.js");

var SymbolTerminalInteractionView = function (gui, interactionModel, parentGroup, layers) {
    var self = this;
    this.gui = gui;
    this.interactionModel = interactionModel;
    this.data = interactionModel.data;

    this.cameraModel = this.gui.editorModel.cameraModel();

    this.initGroups(parentGroup, [layers.draw, layers.control]);

    this.elementSvgGroup = this.getGroupInfo(layers.draw).svgGroup;
    this.controlGroup = this.getGroupInfo(layers.control).svgGroup;

    if(this.interactionModel.handle) {
        this.handle = new editor_2d.HandleView(self, this.gui, 0, this.interactionModel.handle(), parentGroup, layers);
    }

    $(this.controlGroup).mousedown(function(event){
        return self.onMouseDown(event);
    });

    this.draw();

    if(this.interactionModel) {
        this.interactionModel.selected.onChange(this, function (value, old) {
            if (self.data.isAlive()) self.setSelected(value);
        }, 10);
    }

    this.data.onBubble(this, function (event) {
        if (self.data.isAlive()) {
            self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.draw, self, [], self);
        }
    }, 10);

    this.cameraModel.viewS.onChange(self, function(){
        if (self.data.isAlive()) {
            self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.draw, self, [], self);
        }
    },10);
};
lib_core.mixin(SymbolTerminalInteractionView, editor_2d.DrawingElement);

module.exports = SymbolTerminalInteractionView;

SymbolTerminalInteractionView.prototype.draw = function () {
    var self = this;

    $(this.elementSvgGroup).empty();
    $(this.controlGroup).empty();

    // draw visible
    drawSymbolTerminalDataTo2D(this.gui.svg, this.elementSvgGroup, this.data);

    // draw control
    drawSymbolTerminalDataTo2D(this.gui.svg, this.controlGroup, this.data);
    $(this.controlGroup).attr("stroke-width", 2 + 4 / self.cameraModel.viewS()); // make control a little larger


};

SymbolTerminalInteractionView.prototype.onMouseDown = function (event) {
    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.ELEMENT_MOUSE_DOWN)
        .fromJSEvent(event)
        .element( this.interactionModel )
        .data( 'mouseCoord', this.gui.relativeMouseCoord(event) );

    return this.gui.stateMachine.handle(cEvent);
};
